angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListListController', function(
	CONFIG,
	$rootScope, $scope, $state, $stateParams,
	$confirm, InvitationListCreateService,
	EventListService, InvitationListListService, InvitationListDeleteService
) {
	$scope.invitationsLists = [];
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );
	$rootScope.getEventFields( $stateParams.event_id );

	$scope.totalInvitations = 0;
	$scope.totalSent        = 0;
	$scope.totalConfirmed   = 0;
	$scope.totalWaiting     = 0;
	$scope.totalRefused     = 0;
	$scope.totalCheckedIn   = 0;

	$scope.mediaFields = [];
	$scope.$on('event_field_loaded', function() {
		angular.forEach($rootScope.eventFieldData, function(eventField, key) {
			if ( eventField.type === 'image' || eventField.type === 'file' ) {
				$scope.mediaFields.push( eventField );
			}
		});
	});

	$scope.loadInvitationsLists = function() {
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {

					var totalInvitations = 0,
						totalSent        = 0,
						totalConfirmed   = 0,
						totalWaiting     = 0,
						totalRefused     = 0,
						totalCheckedIn   = 0;

					angular.forEach(data, function(il, key) {
						if ( il.stage ) {
							data[key].stage.from_date = moment.unix( il.stage.from_date ).toDate();
							data[key].stage.to_date   = moment.unix( il.stage.to_date ).toDate();
						}

						totalInvitations += data[key].invitations_count;
						totalSent        += data[key].sent_count;
						totalConfirmed   += data[key].confirmed_count;
						totalWaiting     += data[key].waiting_count;
						totalRefused     += data[key].refused_count;
						totalCheckedIn   += data[key].checked_in_count;
					});

					$scope.totalInvitations = totalInvitations;
					$scope.totalSent        = totalSent;
					$scope.totalConfirmed   = totalConfirmed;
					$scope.totalWaiting     = totalWaiting;
					$scope.totalRefused     = totalRefused;
					$scope.totalCheckedIn   = totalCheckedIn;

					$scope.invitationsLists = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.loadInvitationsLists();

	$scope.cloneInvitationList = function(invitationListId) {

		$confirm({
			title: 'Sei sicuro di voler duplicare la Tipologia Lista?',
			text: 'Confermi la duplicazione della Tipologia Lista?'
		}).then(function() {

			$scope.showLoader();
			InvitationListCreateService
				.clone( invitationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$scope.showSuccessMsg('Tipologia Lista duplicata con successo!', '');

						$state.go('app.invitation_list.edit', { event_id: data.event_id, id: data.id });
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

	$scope.deleteInvitationList = function(invitationListId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare la Tipologia Lista?',
			text: 'Confermi la cancellazione della Tipologia Lista?'
		}).then(function() {

			$scope.showLoader();
			InvitationListDeleteService
				.delete( invitationListId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.invitationsLists, function(invitationList, key) {
							if ( invitationList.id == invitationListId ) {
								$scope.invitationsLists.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Tipologia Lista eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};


	$scope.downloadExportEvent = false;
	$scope.exportEventUrl      = '';

	$scope.prepareExportEventUrl = function() {
		$scope.showLoader();
		EventListService
			.exportEvent( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportEvent = true;
					$scope.exportEventUrl      = url;
				}
			});
	};


	$scope.downloadExportAvatarZip = false;
	$scope.exportAvatarZipUrl      = '';
	$scope.prepareAvatarZip = function()
	{
		$scope.showLoader();
		InvitationListListService
			.exportAvatarZip( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportAvatarZip = true;
					$scope.exportAvatarZipUrl      = url;
				}
			});

	};


	$scope.downloadAllExportZip = false;
	$scope.exportAllZipUrl      = '';

	$scope.prepareAllCustomFieldsZip = function() {
		$scope.showLoader();
		EventListService
			.exportAllCustomFieldZip( $stateParams.event_id, $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadAllExportZip = true;
					$scope.exportAllZipUrl      = url;
				}
			});
	};


	$scope.prepareCustomFieldZip = function( eventFieldId, index )
	{
		$scope.showLoader();
		InvitationListListService
			.exportCustomFieldZip( eventFieldId, $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.mediaFields[index].downloadExportZip = true;
					$scope.mediaFields[index].exportZipUrl      = url;
				}
			});

	}

});